var _path, _path2, _g, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleMeet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.75 6.33398C25.4989 6.33398 26.9167 7.75175 26.9167 9.50065V28.5007C26.9167 30.2496 25.4989 31.6673 23.75 31.6673H7.52083C5.33471 31.6673 3.5625 29.8951 3.5625 27.709V14.2507C3.5625 9.8784 7.10692 6.33398 11.4792 6.33398H23.75Z",
    fill: "url(#paint0_linear_4458_101738)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4458_101738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 6,
    width: 24,
    height: 26
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.75 6.33398C25.4989 6.33398 26.9167 7.75175 26.9167 9.50065V28.5007C26.9167 30.2496 25.4989 31.6673 23.75 31.6673H7.52083C5.33471 31.6673 3.5625 29.8951 3.5625 27.709V14.2507C3.5625 9.8784 7.10692 6.33398 11.4792 6.33398H23.75Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4458_101738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9165 31.8782V19.002H3.3328V31.8782H26.9165Z",
    fill: "url(#paint1_linear_4458_101738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9165 6.12571V19.002H3.3328V6.12571H26.9165Z",
    fill: "url(#paint2_linear_4458_101738)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.729 26.1245C6.72934 24.7259 7.86308 23.5921 9.26172 23.5918C10.6606 23.5918 11.7956 24.7256 11.796 26.1245C11.796 27.5237 10.6608 28.6588 9.26172 28.6588C7.86288 28.6585 6.729 27.5234 6.729 26.1245Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9165 24.5408V14.2491L33.1914 10.256C34.2454 9.5852 35.6248 10.3424 35.6248 11.5918V27.1981C35.6248 28.4475 34.2454 29.2046 33.1914 28.5339L26.9165 24.5408Z",
    fill: "#F9AC02"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4458_101738",
    x1: 26.9167,
    y1: 15.0423,
    x2: 3.13025,
    y2: 22.8466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FADE13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FADE13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCA03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4458_101738",
    x1: 26.9165,
    y1: 19.002,
    x2: 18.0138,
    y2: 26.2015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#FDBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE66C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4458_101738",
    x1: 26.9165,
    y1: 19.002,
    x2: 18.0138,
    y2: 11.8024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#FDBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE66C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMeet);
export default __webpack_public_path__ + "static/media/google-meet.64e00851890d9f49f759218c46f5a021.svg";
export { ForwardRef as ReactComponent };